import { useEffect } from "react";
import { NaeSSchemaMap } from "../../config/NaeSSchema";
import { useDataCache } from "./DataCacheProvider";
import { useSelector } from "react-redux";
import { SelectorNoteNae } from "../Models/ormSelectors";

interface ChildId {
  id: number
}

export interface INoteModelNae {
    id: number,
scopes: any,
badges: any,

}

export const INoteFieldsNae = [
    "id",
    "scopes",
    "badges"
];

export function useNoteHookNae(id: number) : INoteModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorNoteNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Note.schema,
        fields: INoteFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
